import { PageHeader } from '../../../shared/components/PageHeader';
import { useCurrentUser } from '../../../shared/features/session/components/CurrentUserProvider';
import { EmailOtpCodeForm } from '../features/email-otp/components/EmailOtpCodeForm';
import { EmailOtpStatusCard } from '../features/email-otp/components/EmailOtpStatusCard';
import { RecoveryCodesReveal } from '../components/RecoveryCodesReveal';
import { TotpEnrollmentWizard } from '../features/totp/components/TotpEnrollmentWizard';
import { TotpStatusCard } from '../features/totp/components/TotpStatusCard';
import { useEmailOtp } from '../features/email-otp/hooks/use-email-otp';
import { useTotpEnrollment } from '../features/totp/hooks/use-totp-enrollment';

function AuthenticatorAppSection() {
  const { state } = useCurrentUser();
  const { enrollment, error, submitting, start, verify, finish, disable, cancel } = useTotpEnrollment();
  const user = state.status === 'authenticated' ? state.user : undefined;

  if (enrollment.phase === 'secret') {
    return (
      <TotpEnrollmentWizard
        secret={enrollment.secret}
        qrCodeDataUrl={enrollment.qrCodeDataUrl}
        error={error}
        submitting={submitting}
        onVerify={verify}
        onCancel={cancel}
      />
    );
  }
  if (enrollment.phase === 'recovery-codes') return <RecoveryCodesReveal codes={enrollment.codes} onDone={finish} />;
  return <TotpStatusCard enabled={user?.totpEnabled ?? false} error={error} submitting={submitting} onEnable={() => start()} onDisable={disable} />;
}

function EmailCodesSection() {
  const { state } = useCurrentUser();
  const { setup, error, submitting, start, resend, verify, finish, disable, cancel } = useEmailOtp();
  const user = state.status === 'authenticated' ? state.user : undefined;
  const email = user?.email ?? '';

  if (setup.phase === 'code') {
    return (
      <EmailOtpCodeForm
        email={email}
        displayedCode={setup.displayedCode}
        error={error}
        submitting={submitting}
        onVerify={verify}
        onResend={resend}
        onCancel={cancel}
      />
    );
  }
  if (setup.phase === 'recovery-codes') return <RecoveryCodesReveal codes={setup.codes} onDone={finish} />;
  return (
    <EmailOtpStatusCard email={email} enabled={user?.emailOtpEnabled ?? false} error={error} submitting={submitting} onEnable={start} onDisable={disable} />
  );
}

export function SecurityPage() {
  return (
    <>
      <PageHeader
        breadcrumbs={[{ label: 'Account' }]}
        title="Security"
        description="Add a second step at sign-in. Turn on one method or both; with both on, you choose at sign-in."
      />
      <div className="max-w-lg space-y-4">
        <AuthenticatorAppSection />
        <EmailCodesSection />
      </div>
    </>
  );
}
